import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Hero from './components/Hero';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ValueProps from './components/ValueProps';
import HowItWorks from './components/HowItWorks';
import WhyChooseUs from './components/WhyChooseUs';
import BenefitsForBusiness from './components/BenefitsForBusiness';


function App() {
  return (
    <div>
     <Header/>
     <Hero/>
     <ValueProps/>
     <HowItWorks/>
     <WhyChooseUs/>
     <BenefitsForBusiness/>
     <Testimonials/>
     <Pricing/>
     <Footer/>
    </div>
  );
}

export default App;
